import { Box, Popover, Typography, Button, Divider, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import i18n from '../../i18n';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            '&  .MuiPaper-root': {
                width: 300,
                boxShadow: 'rgba(0,0,0,0.05) 0px 1px 2px 0px',
                border: '1px solid rgba(0, 0, 0, 0.12)'
            }
        },
        title: {
            textAlign: 'center',
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
            padding: 8
        },
        avatar: {
            background: theme.palette.primary.main
        },
        listItem: {
            cursor: 'pointer'
        }
    })
)

//  Popover组件
export default function TopBarPopover(props: {
    // Popover 开关
    open: boolean;
    // Popover 锚点
    anchorEl: HTMLElement | null;
    // 关闭Popover
    onClose: () => void;
    // 底部按钮跳转
    handleClick: () => void;
    // 内容
    content: JSX.Element;
    // 标题
    title: string;
    // 新数据
    newCount: number;
    id: string;
}) {
    const classes = useStyles();
    const { open, anchorEl, onClose, handleClick, title, content, newCount, id } = props;
    return (
        <Popover
            id={open ? id : undefined}
            className={classes.root}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            elevation={8}
        >
            <Box className={classes.title}>
                <Typography variant='subtitle1'>
                    {title}
                </Typography>
            </Box>
            {
                newCount > 0 ?

                    content
                    :
                    <Box>
                        <Box display='flex' alignItems='center' justifyContent='center' height={100}>
                            {i18n.t('public_text_no_data')}
                        </Box>
                        <Divider />
                    </Box>

            }
            <Box sx={{ display: 'flex', justifyContent: 'center', padding: 4 }}>
                <Button size='small' disableRipple onClick={handleClick}>
                    <Typography >
                        show all
                    </Typography>
                </Button>
            </Box>
        </Popover >
    )

}